module.exports = __webpack_public_path__ + "1c8e04c98d1da7388c7e5fb460039af8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/columbia_university_2_2023_chart.png
// module id = 1658
// module chunks = 0